import { HttpClient } from "@angular/common/http";
import { NGXLogger } from "ngx-logger";
import { Injectable } from "@angular/core";

@Injectable()
export class BankDashboardService {
    constructor(private http: HttpClient,
        private logger: NGXLogger) { }

    getBankPaymentTxnsAmountForBoth(obj): any {
        return this.http.post('/honcho/api/dashboard/bank/payment-txns-amount/view', obj, { observe: 'response' });
    }
    getBankPaymentSuccessFailureRateForBoth(obj): any {
        return this.http.post('/honcho/api/dashboard/bank/payment-success-rate/view', obj, { observe: 'response' });
    }
    getTopRecordsView(obj): any {
        return this.http.post('/honcho/api/dashboard/bank/top-records/view', obj, { observe: 'response' });
    }
    getRegisteredBanks(obj): any {
        return this.http.post('/honcho/api/dashboard/bank/ekpay-txns-reg-data/view', obj, { observe: 'response' });
    }
}


// WEBPACK FOOTER //
// ./src/app/dashboards/bank-dashboard/bank-dashboard.service.ts